import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useWarehouseTags = (enabled?: boolean) => {
  const api = useAPI();
  return useQuery({
    queryKey: ['warehouse-tags'],
    queryFn: () =>
      api
        .postBackSupplyWarehouseTagListFilter({
          postBackSupplyWarehouseTagListFilterRequest: {
            data: {},
          },
        })
        .then((res) => res.result.data),
    enabled,
  });
};
